<script>
    import {Row} from "svelte-layouts";
    import Icon from "../Icon.svelte";

    export let label = "";
    export let disabled = false
    //probably better to pass icon as a prop
    export let leadingIcon = ""
    export let trailingIcon = ""
    export let type = 'filled'
    export let size = 'big'
    export let width = size === 'big' ? '68px' : '56px'
    export let handleClick = ()=>{console.log('where is the click handler?')}

    // if(width===''){
    //     width = size === 'big' ? '68px' : '56px'
    // }
</script>

<button class="{type}" on:click={handleClick} style="width:{width};  height:{size==='big' ? '34px' : '24px'};
     border: 2px solid #0043A4; border-radius: 5px; padding: 0">
    <Row justifyContent="center" alignItems="center">
        {#if leadingIcon}
            <Icon name={leadingIcon} height="18px" width="18px"/>
        {/if}
        <div class="{size}" style="padding: 0 5px 0 5px;">{label}</div>
        {#if trailingIcon}
            <Icon name={trailingIcon} height="18px" width="18px"/>
        {/if}
    </Row>
</button>

<style>
    button:hover{
        border-color: #102743 !important;
        transition: 0.5s;
    }
    .filled:hover{
        background-color: #102743;
        /*transition: 2s;*/
    }
    .filled{
        background-color: #0043A4;
        color: white;
    }
    .outlined:hover{
        color: #102743;
    }
    .outlined{
        background-color: white;
        color: #0043A4;
    }

    .big{
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        align-items: center;
    }

    .small{
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        align-items: center;
    }
</style>